import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { map, publishLast, refCount } from 'rxjs/operators';
import { SettingsService } from '../settings/settings.service';
import { AsyncPipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ExtendedCookieConsentComponent } from '@app/core/cookie-consent/extended-cookie-consent/extended-cookie-consent.component';
import { SimpleCookieConsentComponent } from '@app/core/cookie-consent/simple-cookie-consent/simple-cookie-consent.component';
import { TranslationsService } from '@app/core/settings/translations.service';

@Component({
  selector: 'app-cookie-consent',
  templateUrl: './cookie-consent.component.html',
  imports: [
    AsyncPipe,
    TranslateModule,
    ExtendedCookieConsentComponent,
    SimpleCookieConsentComponent,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieConsentComponent {
  public readonly settings$ = this.settingsService.getSettingsOnce().pipe(publishLast(), refCount());
  public readonly consentsTranslations$ = inject(TranslationsService).getConsentTranslations();

  public readonly extendedCookieBanner$ = this.settings$.pipe(
    map(settings => settings.new_cookie_banner || false),
  );

  constructor(private settingsService: SettingsService) {
  }

}
